import React, {ReactNode} from "react";
import { Box, Typography } from "@mui/material";

interface MyTaxApplicationCardInfoItemProps {
  label: string;
  value: string | number | ReactNode;
  disabled?: boolean;
  isMobile: boolean;
}

const MyTaxApplicationCardInfoItem: React.FC<
  MyTaxApplicationCardInfoItemProps
> = ({ label, value, disabled, isMobile }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      paddingBottom="10px"
      justifyContent={isMobile ? "space-between" : "unset"}
    >
      <Box width={isMobile ? "auto" : "221px"} textAlign="right">
        <Typography variant="body1" color={disabled ? "info" : "primary"}>
          {label}
        </Typography>
      </Box>
      <Box width="16px" />
      <Box>
        <Typography
          style={{
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "24px",
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyTaxApplicationCardInfoItem;
